import { isLocalUrl } from '../../helpers/helpers';
export default function mainSeoBlock() {
  const widgetName = 'mainSeoBlock';
  const widgetOpts = mainSeoBlockOpts;
  const $widget = $(`#${widgetName}`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createMainSeoBlock(data.items[0]);
      } else {
        $(`#${widgetName}`).remove();
      }
    },
  });

  function createMainSeoBlock(widgetData) {
    const { Title, Description, URL } = widgetData;
    const $seo = $widget.find('.card-widget-item');
    const localUrl = isLocalUrl(URL) ? '' : 'target="_blank"';

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
      ${URL == null ? '' : `<a href="${URL}" class="button" ${localUrl}>Learn More</a>`}

    `);
  }
}
